import { Paper } from '../types';

/**
 * Generates a BibTeX entry for a paper.
 */
export const generateBibTeX = (paper: Paper): string => {
    // Sanitize title: remove HTML tags and escaping special characters is usually handled by BibTeX engines
    // but we should at least remove the HTML tags provided by OpenAlex
    const cleanTitle = paper.title.replace(/<[^>]+>/g, '');

    // Format authors: BibTeX expects "Author 1 and Author 2 and Author 3"
    const authors = paper.authorships
        .map(a => a.author.display_name)
        .join(' and ');

    // Generate a simple key: FirstAuthorYearFirstWordOfTitle
    const firstAuthor = paper.authorships.length > 0
        ? paper.authorships[0].author.display_name.split(' ').pop() || 'Unknown'
        : 'Unknown';
    const titleWord = cleanTitle.split(' ')[0].replace(/[^a-zA-Z]/g, '');
    const key = `${firstAuthor}${paper.publication_year}${titleWord}`;

    const journal = paper.venue || 'ArXiv';
    const doiLine = paper.doi ? `  doi = {${paper.doi}},` : '';

    return `@article{${key},
  title = {${cleanTitle}},
  author = {${authors}},
  year = {${paper.publication_year}},
  journal = {${journal}},${doiLine ? '\n' + doiLine : ''}
  url = {${paper.doi || paper.primary_location?.pdf_url || ''}}
}`;
};
